// extracted by mini-css-extract-plugin
module.exports = {"DetailsPanel":"Bookings_DetailsPanel__1sNdw","title":"Bookings_title__18yKg","detailBookingInfo":"Bookings_detailBookingInfo__26fro"};